// extracted by mini-css-extract-plugin
module.exports = {"slider-main":"styles-m__slider-main__1aoGy","mobile-hide":"styles-m__mobile-hide__2Ia_W","main-slider-collection":"styles-m__main-slider-collection__1y2Op"};